import { render, staticRenderFns } from "./productservice.vue?vue&type=template&id=002a5cd3&scoped=true&"
import script from "./productservice.vue?vue&type=script&lang=js&"
export * from "./productservice.vue?vue&type=script&lang=js&"
import style0 from "./productservice.scss?vue&type=style&index=0&id=002a5cd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a5cd3",
  null
  
)

export default component.exports